import { CommonModule } from '@angular/common';
import { DestroyRef, EventEmitter, inject } from '@angular/core';
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { CoreFrontendSharedModule } from '@core/frontend-shared';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { BehaviorSubject } from 'rxjs';
import { MembershipRegistrationFormDataTableComponent } from '../../components';
import { MembershipDisplayMode } from '../../state';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
function MembershipRegistrationPluginSummaryComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "membership-registration-form-data-table", 1);
    i0.ɵɵlistener("onClickEdit", function MembershipRegistrationPluginSummaryComponent_For_1_Template_membership_registration_form_data_table_onClickEdit_0_listener() {
      const dataset_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChangeFormData.emit(dataset_r2.id));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataset_r2 = ctx.$implicit;
    i0.ɵɵproperty("displayEdit", true)("header", dataset_r2.title)("rows", dataset_r2.rows);
  }
}
export let MembershipRegistrationPluginSummaryComponent = /*#__PURE__*/(() => {
  class MembershipRegistrationPluginSummaryComponent {
    constructor() {
      this.destroyRef = inject(DestroyRef);
      this.dataRows$ = new BehaviorSubject([]);
      // requests to go back to pluginForm in order to modify data.
      // if output emits data, it will be passed to pluginForm as state.
      this.onChangeFormData = new EventEmitter();
    }
    ngOnInit() {
      this.generateRows(this.data);
    }
    generateRows(data) {
      if (this.rowsSubscription) this.rowsSubscription.unsubscribe();
      this.rowsSubscription = this.plugin.generateSummaryData(data, this.requireAccountData).pipe(takeWhileAlive(this.destroyRef)).subscribe(dataRows => this.dataRows$.next(dataRows));
    }
    static {
      this.ɵfac = function MembershipRegistrationPluginSummaryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembershipRegistrationPluginSummaryComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MembershipRegistrationPluginSummaryComponent,
        selectors: [["membership-registration-plugin-summary"]],
        inputs: {
          plugin: "plugin",
          data: "data",
          displayMode: "displayMode",
          requireAccountData: "requireAccountData"
        },
        outputs: {
          onChangeFormData: "onChangeFormData"
        },
        decls: 3,
        vars: 2,
        consts: [[3, "displayEdit", "header", "rows"], [3, "onClickEdit", "displayEdit", "header", "rows"]],
        template: function MembershipRegistrationPluginSummaryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, MembershipRegistrationPluginSummaryComponent_For_1_Template, 1, 3, "membership-registration-form-data-table", 0, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵpipe(2, "async");
          }
          if (rf & 2) {
            i0.ɵɵrepeater(i0.ɵɵpipeBind1(2, 0, ctx.dataRows$));
          }
        },
        dependencies: [CommonModule, CoreFrontendSharedModule, UiIconsModule, MembershipRegistrationFormDataTableComponent, i1.AsyncPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MembershipRegistrationPluginSummaryComponent;
})();